import * as Sentry from '@sentry/react';
import { useCallback } from 'react';

import { usePagesContext } from '../context/PagesContext';
import { WizardPageAction } from '../store/wizard/wizard';

/**
 * A convenience hook that will create an onAction function for going forward and back in a Pages component
 *
 * @returns a function for handling actions
 */
const useDefaultPagesAction = () => {
    const { setCurrentPage, currentPage, numberOfPages, setPageAction } = usePagesContext();

    return useCallback(
        async (action: WizardPageAction) => {
            if (action === 'next') {
                if (currentPage < numberOfPages) {
                    setCurrentPage(currentPage + 1);
                } else {
                    Sentry.captureException(
                        new Error(`There are no more pages to show, current page is ${currentPage} of total ${numberOfPages} pages`),
                    );
                    return false;
                }
            } else if (action === 'consolidation-next') {
                if (currentPage < numberOfPages) {
                    setCurrentPage(currentPage + 1);
                } else {
                    Sentry.captureException(
                        new Error(`There are no more pages to show, current page is ${currentPage} of total ${numberOfPages} pages`),
                    );
                    return false;
                }
            } else if (action === 'back') {
                if (currentPage > 0) {
                    setCurrentPage(currentPage - 1);
                } else {
                    Sentry.captureException(new Error(`Can not go back, we are at the start page`));
                    return false;
                }
            }
            setPageAction(action);
            return true;
        },
        [setCurrentPage, currentPage, numberOfPages],
    );
};

export default useDefaultPagesAction;
